import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CommuteRocket = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 2C18.925 2 13.588 5.2 10.588 10H9C5.138 10 2 13.137 2 17V19C2 19.55 2.45 20 3 20H8.588L9.588 21L6.301 24.288C6.126 24.463 6.014 24.713 6.014 25C6.014 25.55 6.464 26 7.014 26C7.289 26 7.539 25.887 7.727 25.712L11.002 22.412L12.002 23.412V29C12.002 29.55 12.452 30 13.002 30H15.002C18.864 30 22.002 26.863 22.002 23V21.413C26.802 18.401 30.002 13.063 30.002 7.001C30.002 4.238 27.764 2.001 25.002 2.001L25 2ZM8.025 18H4V17C4 14.238 6.237 12 9 12H9.512C8.674 13.85 8.149 15.875 8.024 18H8.025ZM20 23C20 25.762 17.762 28 15 28H14V23.975C16.125 23.85 18.15 23.338 20 22.5V23ZM13.412 22L12.412 21L13.699 19.712C13.874 19.537 13.986 19.287 13.986 19C13.986 18.45 13.536 18 12.986 18C12.711 18 12.461 18.113 12.273 18.288L10.998 19.588L9.998 18.588C10.223 10.513 16.86 4 24.998 4C26.648 4 27.998 5.35 27.998 7C27.998 15.137 21.486 21.775 13.41 22H13.412Z" />
		<path d="M20 8C17.8 8 16 9.8 16 12C16 14.2 17.8 16 20 16C22.2 16 24 14.2 24 12C24 9.8 22.2 8 20 8ZM20 14C18.9 14 18 13.1 18 12C18 10.9 18.9 10 20 10C21.1 10 22 10.9 22 12C22 13.1 21.1 14 20 14Z" />
	</svg>
);

export default CommuteRocket;
